$(document).ready(function () {

    var dataAtual = new Date();
    dataAtual = dataAtual.getDate() + '/' + (dataAtual.getMonth() + 1) + '/' + dataAtual.getFullYear();

    $('#dateRange').datepicker({
        format: 'dd/mm/yyyy',
        autoclose: true,
        todayHighlight: true,
        startDate: dataAtual,
        language: 'pt-BR'
    });

    // Função para remover caracteres especiais
    function removeSpecialCaracters(str) {
        return str.replace(/[^\w\s]/gi, '');
    }

    /**
     * CLICK SUBMIT FORM BOOKING
     */
    $("body").on("click", "#submitFormBooking", function(e) {
        e.preventDefault();
        submitFormBooking();
    });

    /**
     * SUBMIT FORM BOOKING NAV
     */
    function submitFormBooking() {

        var formDataArray = $('#formBooking').serializeArray();

        // Convert the array to an object
        var formDataObject = {};
        $.each(formDataArray, function (i, field) {
            formDataObject[field.name] = field.value;
        });
        var data = formDataObject;


        //valida se foi inserido a(s) idade(s) da(s) crianca(s)
        if (data.children > 0) {
            data.childrenAge = $('#childrenAge').val();

            if (data.childrenAge == 'undefined' || data.childrenAge == '') {
                //modalBootstrapShow('md', 'Ops...', '<div class="alert alert-warning mb-0 text-center">É necessário informar a idade das crianças.</div>');
                modalAgeChildren(data.children);
                return;
            }

            $childrenAgeArray = data.childrenAge.split(';');
            if ($childrenAgeArray.length != data.children) {
                modalAgeChildren(data.children);
                return;
            }
        }

        //define url (se escolheu criança envia a idade das crianças tbm)
        var url = '';
        if (data.children > 0) {
            var url = data.url + '?q=' + data.q  + '&lang=pt-BR' + '&CheckIn=' + removeSpecialCaracters(data.checkin) + '&CheckOut=' + removeSpecialCaracters(data.checkout) + '&NRooms=1&ad=' + data.adult + '&ch=' + data.children + '&ag=' + data.childrenAge;
        } else {
            var url = data.url + '?q=' + data.q  + '&lang=pt-BR' + '&CheckIn=' + removeSpecialCaracters(data.checkin) + '&CheckOut=' + removeSpecialCaracters(data.checkout) + '&NRooms=1&ad=' + data.adult + '&ch=' + data.children;
        }

        window.open(url, '_blank');
    };


    /**
     * MODAL INSERIR CRIANÇAS
     */
    function modalAgeChildren(qty) {

        if (qty > 0) {
            var title = '';
            if (qty == 1) {
                title =  'Informe a idade da criança:';
            } else {
                title =  'Informe a idade das crianças:';
            }

            //monta conteudo
            var content = '';
            content += '<form id="formAgeChildren" class="ajax_off">'

            //inputs
            for (var i = 1; i <= qty; i++) {
                content += inputAgeChildren(i);
            }

            //botao confirmar
            content += '<div class="text-end">' +
                '<button type="button" class="btn btn-primary text-white" id="btnAgeChildrenConfirm">CONFIRMAR</button>' +
                '</div>';

            content += '</form>';

            //abre modal
            modalBootstrapShow('sm', title, content);
            return;
        }

    };


    /**
     * MONTA INPUT IDADE DA CRIANÇA
     * @param numberId
     * @returns {string}
     */
    function inputAgeChildren(numberId) {
        return '<div class="mb-3">\n' +
            '    <label class="form-label">Criança ' + numberId + '</label>\n' +
            '    <input type="number" class="form-control js_limitChar" minlength="0" maxlength="12" name="childrenAge' + numberId + '">\n' +
            '</div>';
    }

    /**
     * LIMITAÇÂO DE IDADE
     */
    $("body").on("input", ".js_limitChar", function(e) {
        var currentValue = this.value;
        var minChars = 0;
        var maxChars = 12;

        if (currentValue < minChars) {
            this.value = minChars;
        } else if (currentValue > maxChars) {
            this.value = maxChars;
        }
    });


    /**
     * CONFIRMA FORM IDADE DAS CRIANÇAS
     * Guarda valor em um imput hidden
     */
    $("body").on("click", "#btnAgeChildrenConfirm", function(e) {
        e.preventDefault();

        //obtem valores
        var dataForm = $('#formAgeChildren').serializeArray();
        var valueInput = '';

        //faz loop e guarda valores (Ex: 2;6;3)
        $.each(dataForm, function(index, field){
            if (valueInput != '') {
                valueInput += ';';
            }
            valueInput += field.value;
        });

        $('#childrenAge').val(valueInput);
        modalBootstrapHide();
        submitFormBooking();
    });

});
